import { observer } from "mobx-react-lite";
import { MdsItemListAsyncNoteRowData } from "@/design-system/components/item-list/types";
import { FC } from "react";
import { useAppStore } from "@/store";
import { MdsItemListItemRow } from "@/design-system/components/item-list/rows/MdsItemListItemRow";

export interface MdsItemListAsyncNoteRowProps {
  data: MdsItemListAsyncNoteRowData;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsItemListAsyncNoteRow: FC<MdsItemListAsyncNoteRowProps> = observer(({ data }) => {
  const { store } = useAppStore();
  const note = store.notes.get(data.payload.noteId);

  if (!note) return null;

  const hasSuggestion = !!note.suggestionData;
  const itemRowData =
    typeof data.payload.itemRow === "function" ? data.payload.itemRow(note) : data.payload.itemRow;

  const isHighlighted = itemRowData.payload.id === itemRowData.payload.listState?.highlightedItemId;
  const isSelected = itemRowData.payload.listState?.isSelected(itemRowData.payload.id);
  let noSeparator = isHighlighted || isSelected || hasSuggestion;
  if (!noSeparator) {
    const nextNoteId = itemRowData.payload.listState?.getNextItemId(itemRowData.payload.id);
    if (nextNoteId) {
      noSeparator = Boolean(
        nextNoteId === itemRowData.payload.listState?.highlightedItemId ||
          itemRowData.payload.listState?.isSelected(nextNoteId) ||
          !!store.notes.get(nextNoteId)?.suggestionData
      );
    }
  }

  return (
    <MdsItemListItemRow
      data={itemRowData}
      hasSuggestion={hasSuggestion}
      noSeparator={noSeparator}
    />
  );
});
